import React, { useState } from "react";
import Header from "./Header";
import { Bmi } from "../BmiStep/Bmi";
const BmiCalculator = ({ onComplete }) => {
  const [fadeClass, setFadeClass] = useState("fade-in");
  return (
    <div className="">
      <Bmi
        onComplete={onComplete}
        fadeClass={fadeClass}
        setFadeClass={setFadeClass}
        redirectTo="none"
      />
    </div>
  );
};

export default BmiCalculator;
